import React, { useState } from 'react';
import BigModalUtil from '../../commonUtils/BigModalUtil';
import './ExcelAnalysisDetailsModal.scss';
import { SplitPanelUtil } from '../../commonUtils/SplitPanelUtil';
import {
  HierarchyTable,
  TreeNode,
  Column,
  TreeTableHeader
} from '../../commonUtils/HierarchyTable';
import i18next from '../../../i18next';

interface IExcelAnalysisDetailsModalProps {
  adminEmail: string;
  address: string;
  organisationName: string;
  onClose: () => void;
  analysisHierarchy: TreeNode[];
  isRepload: boolean;
}

export const ExcelAnalysisDetailsModal = (
  props: IExcelAnalysisDetailsModalProps
) => {
  const [globalFilterQuery, setGlobalFilterQuery] = useState<string>();

  const filterHierarchy = (hierarchy: TreeNode[]) => {
    // Just one layer deep as search behaviour is not defined
    return hierarchy.filter(node => {
      return node.data.name
        .toUpperCase()
        .includes(globalFilterQuery ? globalFilterQuery.toUpperCase() : '');
    });
  };

  return (
    <BigModalUtil
      className="excel-analysis-details-modal"
      header={i18next.t('preview')}
      onClose={props.onClose}
    >
      <BigModalUtil.Content>
        <SplitPanelUtil>
          <SplitPanelUtil.Table>
            <HierarchyTable
              value={
                globalFilterQuery
                  ? filterHierarchy(props.analysisHierarchy)
                  : props.analysisHierarchy
              }
              // value={
              //   globalFilterQuery
              //     ? filterHierarchy(props.analysisHierarchy)
              //     : props.analysisHierarchy
              // }
              header={
                <>
                  <TreeTableHeader
                    selections={1}
                    showActionBar={false}
                    data={[]}
                    searchPlaceholder={i18next.t('searchFor')}
                    globalFilterValue={
                      globalFilterQuery ? globalFilterQuery : ''
                    }
                    onSearchChange={newValue => {
                      setGlobalFilterQuery(newValue);
                    }}
                    hideActionBar={() => {}}
                    search={true}
                    totalRecords={
                      globalFilterQuery
                        ? filterHierarchy(props.analysisHierarchy).length
                        : props.analysisHierarchy.length
                    }
                  />
                </>
              }
            >
              {props.isRepload ? (
                <Column
                  field="changes"
                  header="Changes"
                  className="changes-column"
                  renderer={(cellData: any) => (
                    <>
                      {cellData.creates ? (
                        <div className="colored-count creates">
                          {/* {cellData.creates} */}
                        </div>
                      ) : null}
                      {cellData.updates ? (
                        <div className="colored-count updates">
                          {/* {cellData.updates} */}
                        </div>
                      ) : null}
                      {cellData.deletes ? (
                        <div className="colored-count deletes">
                          {/* {cellData.deletes} */}
                        </div>
                      ) : null}
                    </>
                  )}
                />
              ) : null}
              <Column field="name" header={i18next.t('name')} expander />
              <Column field="type" header={i18next.t('type')} />
              <Column field="address" header={i18next.t('address')} />
            </HierarchyTable>
          </SplitPanelUtil.Table>
        </SplitPanelUtil>
      </BigModalUtil.Content>
      {/* <BigModalUtil.Footer>
        <Button onClick={props.onClose}>Close</Button>
      </BigModalUtil.Footer> */}
    </BigModalUtil>
  );
};
export default ExcelAnalysisDetailsModal;
